import { render } from "./DeniedPrs.vue?vue&type=template&id=69d81d55"
import script from "./DeniedPrs.vue?vue&type=script&lang=js"
export * from "./DeniedPrs.vue?vue&type=script&lang=js"

import "./DeniedPrs.vue?vue&type=style&index=0&id=69d81d55&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__